<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="250px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <!-- CADASTRO -->
                    <!-- <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: #5BC1A3">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">Cadastro</v-card-title>
                            <v-card-subtitle>de Membro</v-card-subtitle>
                            <v-card-actions>
                              <v-btn class="ml-2 mb-2" height="40px" outlined>
                                <router-link to="/liberdade" style="text-decoration: none; color: white">Acessar</router-link>
                              </v-btn>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="100" tile style="top: 13px">
                            <v-icon size="100">mdi-account-plus</v-icon>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col> -->
                    <!-- MATRÍCULA ESCOLA BÍBLICA -->
                    <!-- <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: orange">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">Escola Bíblica</v-card-title>
                            <v-card-subtitle>Matrícula</v-card-subtitle>
                            <v-card-actions>
                              <v-btn class="ml-2 mb-2" height="40px" outlined>
                                <router-link to="/liberdadeeb" style="text-decoration: none; color: white">Acessar</router-link>
                              </v-btn>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="100" tile style="top: 13px">
                            <img src="../../assets/kids.jpeg" alt="">
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col> -->
                    <!-- LOCALIZAÇÃO -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: #4A89F3; border-radius: 16px; box-shadow: 0 4px 16px rgba(0, 37, 62, 0.15)">
                        <div>
                          <div>
                            <v-card-title class="text-h6">
                              <v-icon left>mdi-map-marker</v-icon>
                              Localização
                            </v-card-title>
                            <v-card-subtitle style="padding-bottom: 0px">R. Prof. Joaquim Francisco Veloso Galvão, 1734 - Pedro Gondim, João Pessoa - PB, 58031-130</v-card-subtitle>
                            <v-card-actions style="padding: 0px; margin: 0px 2px 0px 2px">
                              <v-col cols="12" sm="12" md="6" lg="4">
                                <v-btn rounded height="40px" outlined right href="https://goo.gl/maps/RMWB1Bj8PnVkHkWEA" target="_blank" block>Ir</v-btn>
                              </v-col>
                            </v-card-actions>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- INSTAGRAM -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888); border-radius: 16px; box-shadow: 0 4px 16px rgba(0, 37, 62, 0.15)">
                        <div>
                          <div>
                            <v-card-title class="text-h6">
                              <v-icon left>mdi-instagram</v-icon>
                              Instagram
                            </v-card-title>
                            <v-card-subtitle style="padding-bottom: 0px"></v-card-subtitle>
                            <v-card-actions style="padding: 0px; margin: 0px 2px 0px 2px">
                              <v-col cols="12" sm="12" md="6" lg="4">
                                <v-btn rounded height="40px" outlined right href="https://www.instagram.com/igrejadaliberdade/" target="_blank" block>Seguir</v-btn>
                              </v-col>
                            </v-card-actions>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- YOUTUBE -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: #FF0000; border-radius: 16px; box-shadow: 0 4px 16px rgba(0, 37, 62, 0.15)">
                        <div>
                          <div>
                            <v-card-title class="text-h6">
                              <v-icon left>mdi-youtube</v-icon>
                              YouTube
                            </v-card-title>
                            <v-card-subtitle style="padding-bottom: 0px"></v-card-subtitle>
                            <v-card-actions style="padding: 0px; margin: 0px 2px 0px 2px">
                              <v-col cols="12" sm="12" md="6" lg="4">
                                <v-btn rounded height="40px" outlined right href="https://www.youtube.com/@IgrejadaLiberdade" target="_blank" block>Inscrever</v-btn>
                              </v-col>
                            </v-card-actions>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- APP LIBERDADE -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(135deg, #00695C 0%, #01B094 100%); border-radius: 16px; box-shadow: 0 4px 16px rgba(0, 37, 62, 0.15)">
                        <div>
                          <div>
                            <v-card-title class="text-h6">
                              <v-icon left>mdi-web</v-icon>
                              App Liberty
                            </v-card-title>
                            <v-card-subtitle style="padding-bottom: 0px"></v-card-subtitle>
                            <v-card-actions style="padding: 0px; margin: 0px 2px 0px 2px">
                              <v-col cols="12" sm="12" md="6" lg="4">
                                <router-link to="/il" style="text-decoration: none; color: white">
                                  <v-btn rounded height="40px" outlined block>Acessar</v-btn>
                                </router-link>
                              </v-col>
                            </v-card-actions>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- DOAÇÃO -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(135deg, #e45f50, #ef9c74); border-radius: 16px; box-shadow: 0 4px 16px rgba(0, 37, 62, 0.15)">
                        <v-card-title class="text-h6" style="justify-content: center">Doação</v-card-title>
                        <v-card-subtitle style="text-align: center">Complexo da Liberdade</v-card-subtitle>
                        <v-card-text tile style="text-align: center">
                          <img :src="imagemPixDoacao" width="100%" style="max-width: 250px">
                          <v-row dense>
                            <v-col cols="12">
                              <v-text-field dense outlined hide-details id="chavePix" v-model="chavePix" label="Chave Pix" readonly></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-btn rounded dark outlined block @click="doCopy('chavePix')">Copiar Chave Pix</v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="250px">
          </a>
        </div>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import { mapState } from 'vuex'
  import axios from 'axios'
  export default {
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        idIgreja: '6390de5538a3bc18300a2022',
        imagemPixDoacao: require('../../assets/qrCodeDoacao.png'),
        chavePix: 'complexodaliberdade@gmail.com',
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        igreja: {},
        isLoading: false,
      }
    },

    mounted: function () {
      this.carregaDados()
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        try {
          const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
          if (response.data) {
            this.igreja = response.data
          }
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Erro ao carregar dados da igreja.'
        } finally {
          this.isLoading = false
        }
      },
      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>
